import PasswordSent from '../../components/login/PasswordSent';

const PasswordSentPortal = (props) => (
  <PasswordSent {...props} />
);

export default PasswordSentPortal;
